import React from "react";
import { Navigate } from 'react-router-dom'

import Login from '@/pages/login'
import AvoidLogin from '@/pages/avoid_login'
import Structure from '@/pages/structure'
import Video from '@/pages/video'

import NewPipelineInspection from '@/pages/new_pipeline_inspection/index.js' //管道巡检新版本
import GIS from '@/pages/GIS/index.js' //GIS
import PipelineOverview from '@/pages/pipeline_overview/index.js' //管道总览

import RoutineList from '@/pages/routine/list' //常规-列表-巡检 
import FixedPointList from '@/pages/fixedPoint/list' //定点-列表-巡检 
import FixedPointListRiskSet from '@/pages/fixedPoint/list/riskSet' //定点-列表-风险设置
import RoutineRecordInfo from "@/pages/routine/record/routine_record_info.js";//常规巡检记录-详细信息
import RoutineRecord from "@/pages/routine/record";//常规-记录-巡检
import FixedPointRecord from "@/pages/fixedPoint/record";//定点-记录-巡检

import EmergencySupportRecord from "@/pages/emergency_support_record/index.js";//应急保障记录

import MapReadout from '@/pages/mapReadout/index.js' // 读数地图
import MapInspection from '@/pages/mapInspection' // 巡检地图

import NewPipelineInspectionEditMap from '@/pages/new_pipeline_inspection/edit_map/index.js' // 新管线巡检_航线编辑_巡检地图

// import MapInspectionNew from '@/pages/map_inspection_new/index.js' // 巡检地图

import ShippingLineOverview from '@/pages/shipping_line_overview' // 巡检地图

import Airport from '@/pages/airportSettings/index.js' // 机场设置

// import Anomalous from '@/pages/anomalous/index.js' //异常

import AbnormalTroubleshooting from '@/pages/abnormalTroubleshooting' //异常排查

import ConventionalRisks from '@/pages/conventional_risks/index.js' //常规风险
import FixedPointRisk from '@/pages/fixedPoint/risk/index.js' //定点风险

import ConventionalRisksHandle from '@/pages/conventional_risks/conventional_risks_handle.js' //异常排查步骤

import TaskPlan from '@/pages/taskPlan' //任务规划

import PatrolMap from '@/pages/patrolMap/index.js' //展示地图

import FlightMap from "@/pages/flight";//飞行

import ChangePassword from "@/pages/changePassword";//修改密码

// import UsersManual from "@/pages/usersManual";//用户手册
import PermissionSettings from "@/pages/permission_settings";//权限设置
import RiskIdentification from '@/pages/risk_identification';//风险识别
import SMSNotification from "@/pages/SMS_notification/index.js"//短信通知

import RecordRoutine from "@/pages/record_routine";//常规巡检记录
import RecordRoutineInfo from "@/pages/record_routine/record_routine_info.js";//常规巡检记录-详细信息

import RecordLeak from "@/pages/record_leak";//高危巡检记录
import RecordLeakInfo from "@/pages/record_leak/record_leak_info.js";//高危巡检记录-详细信息

import RecordAccurate from "@/pages/record_accurate";//定点巡检记录
import RecordAccurateInfo from "@/pages/record_accurate/record_accurate_info.js";//定点巡检记录-详细信息

import InspectionReport from "@/pages/inspection_report" //巡检报告

import RiskHandlers from "@/pages/risk_handlers" //风险处理员
import RiskHandlersTeam from "@/pages/risk_handlers/team.js" //风险处理员

import Record from "@/pages/record";//巡检记录

import GodMap from "@/pages/godMap/index.js";//巡检上帝图

import NewGodmap from '@/pages/godMap/newGodmap.js'

import AirportCamera1 from '@/pages/airportCamera/index.js';//机场监控镜头一体版
import AirportCamera from '@/pages/airport_camera/index.js';//新版机场镜头
import AirportSurveillance from '@/pages/airport_surveillance/index.js';//新版机场监控-列表
import SurveillanceInfo from '@/pages/airport_surveillance/surveillance_info.js';//新版机场监控-详情

import ShippingLineBuildSegment from '@/pages/shipping_line_build_segment/index.js' //生成单元段
import Demo from '@/pages/demo/index.js' //生成单元段




export const basicPath = '/dock';//基础路径
export const redirectPath = '/Video';//主页重定向路径
export const startPath = '/login';//初始路径1
export const StartComp = Login;

export const startPath2 = '/avoid_login';//初始路径2
export const StartComp2 = AvoidLogin;


export const RouterConfig = [
  // { path: "/login", title: "登录", exact: true, component: Login },
  // { path: "/avoid_login", title: "登录", exact: true, component: AvoidLogin },

  {
    path: "/", title: "框架", exact: true, component: Structure,
    children: [
      { path: "/Video", title: "实时画面", exact: true, component: Video },
      { path: "/AirportCamera", title: "机场镜头", exact: true, component: AirportCamera1 },
      { path: "/airport_camera", title: "机场镜头", exact: true, component: AirportCamera },
      { path: "/airport_surveillance", title: "机场监控", exact: true, component: AirportSurveillance },



      // { path: "/ShippingLineRoutine", title: "常规巡检", exact: true, component: RoutineList },
      // { path: "/ShippingLineLeak", title: "高危巡检", exact: true, component: RoutineList },
      // { path: "/ShippingLinePrecise", title: "定点巡检", exact: true, component: RoutineList },

      { path: "/new_pipeline_inspection", title: "(新)管道巡检", exact: true, component: NewPipelineInspection },
      { path: "/routine_list_powerGrid_new", title: "电网巡检-新", exact: true, component: NewPipelineInspection },
      { path: "/GIS", title: "GIS", exact: true, component: GIS },

      { path: "/routine_list_conduit", title: "管道巡检", exact: true, component: RoutineList },
      { path: "/routine_list_powerGrid", title: "电网巡检", exact: true, component: RoutineList },

      { path: "/fixedPoint_list_electricTower", title: "电塔巡检", exact: true, component: FixedPointList },
      { path: "/fixedPoint_list_station", title: "场站巡检", exact: true, component: FixedPointList },
      { path: "/fixedPoint_list_riskSet", title: "定点巡检-风险设置", exact: true, component: FixedPointListRiskSet },


      { path: "/TaskPlan", title: "任务规划", exact: true, component: TaskPlan },

      { path: "/AbnormalTroubleshooting", title: "异常排查", exact: true, component: AbnormalTroubleshooting },

      // { path: "/conventional_risks", title: "常规风险", exact: true, component: ConventionalRisks },
      // { path: "/conventional_risks_handle", title: "常规风险处理", exact: true, component: ConventionalRisksHandle },
      // { path: "/leakage_risk", title: "高危风险", exact: true, component: RiskLeakage },
      // { path: "/leak_handle", title: "高危风险处理", exact: true, component: LeakHandle },


      { path: "/routine_record_conduit", title: "管道巡检记录(常规) ", exact: true, component: RoutineRecord },
      { path: "/routine_record_powerGrid", title: "电网巡检记录(常规) ", exact: true, component: RoutineRecord },
      { path: "/routine_record_info", title: "常规巡检记录详情", exact: true, component: RoutineRecordInfo },
      { path: "/fixedPoint_record_electricTower", title: "电塔巡检记录(定点) ", exact: true, component: FixedPointRecord },
      { path: "/fixedPoint_record_station", title: "场站巡检记录(定点) ", exact: true, component: FixedPointRecord },

      { path: "/emergency_support_record", title: "应急保障记录 ", exact: true, component: EmergencySupportRecord },



      { path: "/routine_risk_conduit", title: "管道风险(定点) ", exact: true, component: ConventionalRisks },
      { path: "/routine_risk_powerGrid", title: "电网风险(定点) ", exact: true, component: ConventionalRisks },
      { path: "/fixedPoint_risk_electricTower", title: "电塔风险(定点) ", exact: true, component: FixedPointRisk },
      { path: "/fixedPoint_risk_station", title: "场站风险(定点) ", exact: true, component: FixedPointRisk },




      { path: "/conventional_risks_handle", title: "风险处理", exact: true, component: ConventionalRisksHandle },





      // { path: "/record_routine", title: "常规巡检记录 ", exact: true, component: RecordRoutine },
      // { path: "/record_routine_info", title: "常规巡检记录详情", exact: true, component: RecordRoutineInfo },

      // { path: "/record_leak", title: "高危巡检记录 ", exact: true, component: RecordLeak },
      // { path: "/record_leak_info", title: "高危巡检记录详情", exact: true, component: RecordLeakInfo },

      // { path: "/record_accurate", title: "定点巡检记录 ", exact: true, component: RecordAccurate },
      // { path: "/record_accurate_info", title: "定点巡检记录详情", exact: true, component: RecordAccurateInfo },

      { path: "/inspection_report", title: "巡检报告 ", exact: true, component: InspectionReport },

      { path: "/record_command_flight", title: "采集读数记录 ", exact: true, component: Record },

      { path: "/risk_handlers", title: "风险处理员-人员", exact: true, component: RiskHandlers },
      { path: "/risk_handlers_team", title: "风险处理员-组队", exact: true, component: RiskHandlersTeam },

      { path: "/godMap_conduit", title: "管道巡检上帝图 ", exact: true, component: GodMap },
      { path: "/godMap_powerGrid", title: "电网巡检上帝图 ", exact: true, component: GodMap },
      { path: "/ChangePassword", title: "修改密码 ", exact: true, component: ChangePassword },
      // { path: "/UsersManual", title: "用户手册 ", exact: true, component: UsersManual },
      { path: "/permission_settings", title: "权限设置 ", exact: true, component: PermissionSettings },
      { path: "/SMS_notification", title: "短信通知", exact: true, component: SMSNotification },
      { path: "/risk_identification", title: "风险识别 ", exact: true, component: RiskIdentification },
      { path: "/airport", title: "设置-机场 ", exact: true, component: Airport },
    ]
  },
  { path: "/MapReadout", title: "上帝图 - 读数地图", exact: true, component: MapReadout },
  { path: "/MapInspection", title: "航线编辑 - 巡检地图", exact: true, component: MapInspection },
  { path: "/new_pipeline_inspection_edit_map", title: "新管线巡检_航线编辑_巡检地图", exact: true, component: NewPipelineInspectionEditMap },
  // { path: "/map_inspection_new", title: "新航线编辑 - 巡检地图", exact: true, component: MapInspectionNew },
  { path: "/shipping_line_build_segment", title: "生成单元段", exact: true, component: ShippingLineBuildSegment },
  { path: "/shipping_line_overview", title: "航线总览", exact: true, component: ShippingLineOverview },
  { path: "/FlightMap", title: "无人机飞行", exact: true, component: FlightMap },
  { path: "/NewGodmap", title: "管道上帝图", exact: true, component: NewGodmap },
  { path: "/PatrolMap", title: "展示地图 ", exact: true, component: PatrolMap },
  { path: "/pipeline_overview", title: "管道总览", exact: true, component: PipelineOverview },

  { path: "/surveillance_info", title: "机场监控——详情", exact: true, component: SurveillanceInfo },
  { path: "/Demo", title: "机场监控——详情", exact: true, component: Demo },
]
